import React, { useState, useEffect } from "react";
import styles from "./index.module.css";
import FakeButton from "../../../Components/FormComponents/FakeButton";

const Questions = ({ question, options, answer, counter, nextScreen }) => {
  const [uanswer, setAnswer] = useState("");

  useEffect(() => {
    setAnswer(null);
  }, [counter]);

  const handleNextScreen = () => {
    nextScreen({
      isCorrect: answer.toUpperCase() === uanswer.toUpperCase(),
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.title}>{question}</div>
      <div className={styles.scrollView}>
        <div>
          {Object.keys(options).map((item, i) => (
            <div
              key={i}
              onClick={() => setAnswer(item)}
              className={[
                styles.option,
                uanswer === item && styles.selectedOption,
              ].join(" ")}
            >
              <span>{item.toLowerCase()})</span> {options[item]}
            </div>
          ))}
        </div>
      </div>

      <div className={styles.buttonContainer}>
        <FakeButton
          onClick={() => {
            nextScreen({
              isCorrect: false,
            });
          }}
          className={styles.button}
        >
          Пропустити запитання
        </FakeButton>
        <FakeButton
          className={styles.button}
          onClick={handleNextScreen}
          red
          disabled={!uanswer}
        >
          {counter < 40 ? "Продовжити" : "Завершити тест"}
        </FakeButton>
      </div>
    </div>
  );
};

export default Questions;
